import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { getOtherIcons } from 'src/styles/font';
import { OtherIconsSet } from 'src/utils/constants/IconsConstants';

export const backButton = css`
  display: block;
  font-weight: 600;
  line-height: 48px;
  font-size: 15px;
  text-align: center;
  color: ${colors.white};
  margin-top: 1px;
  ${getOtherIcons(OtherIconsSet.LEFT_ARROW_CHEVRON)};
`;
